export enum FeatureType {
    STRING_LIST = 'string-list'
}

export interface IFeature {
    name: string;
    type: FeatureType;
    value: unknown;
    enabled: boolean;
}

export interface IFeatureUpdate {
    value?: unknown;
    enabled?: boolean;
}

export const featureValueAsStringList = (feature: IFeature): string[] =>
    Array.isArray(feature.value) ? feature.value.map(String) : [];

export const normalizeFeature = (input: unknown): IFeature => {
    const row = (input ?? {}) as Record<string, unknown>;
    return {
        name: typeof row.name === 'string' ? row.name : '',
        type: row.type as FeatureType,
        value: row.value,
        enabled: row.enabled === true
    };
};
